import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootVm.jsx'
import meta from './metaCatRootVm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            const {subTypeCode} = map.data

            if ('BODA2' === subTypeCode) {
                return /^(BD|FC|UI)$/.test(type)
            }
            else {
                return /^(FC)$/.test(type)
            }
        },

        menuItemsInsertConcept(map, node) {
            const {subTypeCode} = map.data

            if ('BODA2' === subTypeCode) {
                return [
                    {type: 'BD'},
                    {type: 'UI'},
                    {type: 'FC'},
                ]
            }
            else {
                return [
                    {type: 'FC'},
                ]
            }
        },

        menuItemsInsertProduct(map, node) {
            const {subTypeCode} = map.data

            if ('BODA2' === subTypeCode) {
                return [
                    {type: 'BD'},
                    {type: 'UI'},
                    {type: 'FC'},
                ]
            }
            else {
                return [
                    {type: 'FC'},
                ]
            }
        },
    })
}
